document.addEventListener('DOMContentLoaded', () => {
    const fileInput = document.getElementById('csv-file-upload');
    if (fileInput) {
        fileInput.addEventListener('change', () => {
            fileInput.files.length > 0 && fileInput.closest('form').submit();
        });
    }
});
